import './App.css';
import Header from './components/Header';
import Overlay from './components/Overlay';
import black_hole from './../src/components/assets/black_hole.png';
import bg_music from './../src/components/assets/sound/bg_music.mp3';
import { useState, useEffect } from 'react';
// import anime from 'animejs';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Education from './components/Education';
import Gallery from './components/Gallery';
import Footer from './components/Footer';
import Projects from './components/Projects';
import GitToRoots from './components/GitRoots';

function App() {
  const audio = document.getElementById("audio_tag");
  const [play, setPlay] = useState(false);
  const [tagCollapsed, setTagCollapsed] = useState(false);

  const handleScroll = () => {
    const scrollPos = window.scrollY;
    const windowHeight = window.innerHeight;

    // Calculate progress for the first 100vh of scroll
    // 0 = top of page, 1 = scrolled 100vh
    const progress = Math.min(Math.max(scrollPos / windowHeight, 0), 1);
    document.documentElement.style.setProperty('--scroll-transition', progress);

    // Collapse tag to dot once user scrolls past the overlay
    setTagCollapsed(scrollPos > windowHeight * 0.85);
  };

  useEffect(() => {
    setPlay(true);
    if (audio) {
      audio.play();
    }
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const elementIsVisibleInViewport = (el, partiallyVisible = false) => {
    const { top, left, bottom, right } = el.getBoundingClientRect();
    const { innerHeight, innerWidth } = window;
    return partiallyVisible
      ? ((top > 0 && top < innerHeight) ||
        (bottom > 0 && bottom < innerHeight)) &&
      ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
      : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
  };

  return (
    <div>
      {/* --- interstellar sound --- */}
      {/* <div className="sound_box">
        <img src={black_hole} alt="handle sound" onClick={() => {
          play ? setPlay(false) : setPlay(true);
          play ? audio.pause() : audio.play();
        }} />
        <audio id="audio_tag" src={bg_music} loop="true" />
      </div> */}

      {/* --- persistent availability tag --- */}
      <div className={`availability-tag${tagCollapsed ? ' availability-tag--collapsed' : ''}`}
        onClick={() => document.getElementById('footer')?.scrollIntoView({ behavior: 'smooth' })}
      >
        <span className="availability-tag__dot" />
        <span className="availability-tag__text">Open to werkstudent Jobs · Oct 2026</span>
      </div>

      {/* --- */}
      <Overlay />
      <Header />
      <Skills />
      <Experience />

      <Projects />
      <Education />
      {/* <GitToRoots /> */}
      <Gallery />
      <Footer />
    </div>
  );
}

export default App;

